// extracted by mini-css-extract-plugin
export default {"container":"StageCellRenderer_container__9i9Y-","tag":"StageCellRenderer_tag__Opn+P"};